import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';

// ------------------------------------
// Selectors
// ------------------------------------

/* No need for selectors in this module */

// ------------------------------------
// Reducer
// ------------------------------------

/* No need for reducers in this module */

// ------------------------------------
// Actions
// ------------------------------------

/* No need for actions in this module */

// ------------------------------------
// View / Route
// ------------------------------------
export const TEAMS_LANDING_VIEW = 'TEAMS_LANDING_VIEW';

viewNames[TEAMS_LANDING_VIEW] = 'TeamsLanding';
routes[TEAMS_LANDING_VIEW] = {
  path: '/teams',
};



// WEBPACK FOOTER //
// ./src/app/views/TeamsLanding/module/teamsLanding.js